import React from "react";
import { formatCurrentDate } from "../../utils/dateUtils";

const DateDisplay = ({ 
  className = "", 
  formatOptions = {}
}) => {
  const currentDate = formatCurrentDate(formatOptions);

  return (
    <div className="flex justify-center">
      <span className={`text-lg ${className}`}>
        {currentDate}
      </span>
    </div>
  );
};

export default DateDisplay;